<template>
    <div class="cz-footer">
        <slot></slot> 
    </div>
</template>
<script>
export default {
    name: "cz-footer",
};
</script>
<style scoped>
</style>
